<!-- <app-sub-navigation [icons]="icons" [customerId]="customerId" style="position: absolute; left: 0"></app-sub-navigation> -->
<roots-page-header
  [title]="selectedGroup ? 'Group: ' + selectedGroup.basicName : 'Group'"
  toolTip="Add or remove users and scouts in this group"
  [loading]="loading">
</roots-page-header>
<div mat-dialog-content>
  @if (selectedGroup) {
    <div class="col-12">
      <div class="col-6" style="float: left;">
        <mat-form-field>
          <mat-select matInput placeholder="GET other Customers' Users and Scouts"
            (selectionChange)="customerChanged($event)" name="name" [(value)]="customer">
            @for (customer of customers; track customer) {
              <mat-option [value]="customer">
                <p>
                  <b>{{ customer.name }} </b>
                </p>
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-card appearance="outlined">
          <mat-card-header>
            <mat-card-title class="no-margin">
              <mat-icon style="color: green;"
                matTooltip="Use 'Add User' button to add to group: {{selectedGroup.basicName}}"
                matTooltipPosition="above">
                group_add
              </mat-icon>
              ({{users.length}}) Available Users
            </mat-card-title>
            <!-- <mat-card-subtitle class="text small-text">
            Add users from Available to the Current groups' users
          </mat-card-subtitle> -->
        </mat-card-header>
        <hr />
        <mat-card-content>
          @if (users.length > 0) {
            <div>
              @for (member of users; track member; let i = $index) {
                <ul style="padding: 0; line-break: anywhere;">
                  @if (users.length > 0) {
                    <div class="col-12 narrow-button">
                      <button mat-button color="secondary" matTooltip="Navigate to {{member.name}} details"
                        matTooltipPosition="above" (click)="navigateUrl('customer-users', member)">
                        <span class="big-button-text">{{ member.name }}</span>
                        <br>
                          <span class="small-button-text">({{ member.authUsername }})</span>
                        </button>
                        <button color="secondary" matTooltip="Add User to {{selectedGroup.basicName}}"
                          matTooltipPosition="above" (click)="addUserToGroup(member.id)"
                          class="btn btn-primary w-25 float-right" style="background-color: green;" type="button">
                          Add
                        </button>
                      </div>
                    } @else {
                      <p class="text label-text">No user found on this customer</p>
                      <p class="text small-text">Refresh your search params or select another customer</p>
                    }
                    <hr />
                  </ul>
                }
              </div>
            } @else {
              <button mat-icon-button color="warn" matTooltip="Assign users to this selected group"
                matTooltipPosition="above">
                <mat-icon style="font-size: xxx-large;">close</mat-icon>
                <!-- {{ scout.scoutName }} -->
              </button>
              <p class="text label-text">No user members found!</p>
              <p class="text small-text">Double check the users assigned to this group</p>
            }
          </mat-card-content>
        </mat-card>
        <mat-card appearance="outlined">
          <mat-card-header>
            <mat-card-title class="no-margin">
              <mat-icon style="color: green;"
                matTooltip="Use 'Add Scout' button to add to group: {{selectedGroup.basicName}}"
                matTooltipPosition="above">
                wifi_tethering
              </mat-icon>
              ({{availScouts.length}}) Available Scouts
            </mat-card-title>
            <!-- <mat-card-subtitle class="text small-text">
            Scouts for the currently selected customer
          </mat-card-subtitle> -->
        </mat-card-header>
        <hr />
        <mat-card-content>
          @if (availScouts.length > 0) {
            <div>
              @for (scout of availScouts; track scout; let i = $index) {
                <ul style="padding: 0">
                  @if (scout.scoutId !== null) {
                    <div class="col-12 narrow-button">
                      <button mat-button color="secondary" matTooltip="Navigate to {{scout.assetName}} details"
                        matTooltipPosition="above" (click)="navigateUrl('scouts', scout)">
                        <span class="big-button-text">{{scout.assetName}}</span>
                        <br>
                          @if (scout.assetName != scout.scoutName) {
                            <span class="small-button-text">
                              ({{ scout.scoutName}})
                            </span>
                          }
                        </button>
                        <button color="secondary" matTooltip="Add Scout to {{selectedGroup.basicName}}"
                          matTooltipPosition="above" (click)="addScoutToGroup(scout.scoutId)"
                          class="btn btn-primary w-25 float-right" style="background-color: green;" type="button">
                          Add
                        </button>
                        <hr />
                      </div>
                    } @else {
                      <div class="noScoutId">
                        <button mat-icon-button color="secondary" matTooltip="Not installed. Click to install"
                          matTooltipPosition="above" (click)="navigateOwnership(scout)">
                          <mat-icon class="mat-18" style="color: red">settings</mat-icon>
                        </button>
                        {{ scout.scoutName }}
                        <br />
                        <hr />
                      </div>
                    }
                  </ul>
                }
              </div>
            } @else {
              <button mat-icon-button color="warn" matTooltip="Assign assets to this customer" matTooltipPosition="above"
                (click)="openAssetDialog()">
                <mat-icon style="font-size: xxx-large;">close</mat-icon>
                <!-- {{ scout.scoutName }} -->
              </button>
              <p class="text label-text">No scouts found!</p>
              <p class="text small-text">Double check the assets assigned to this customer</p>
            }
          </mat-card-content>
        </mat-card>
      </div>
      <!-- right column -->
      <div class="col-6" style="float: left;">
        <mat-form-field>
          <mat-select matInput placeholder="Select another related group" (selectionChange)="groupChanged($event)"
            name="name" [(value)]="selectedGroup.id">
            @for (group of customerGroups; track group) {
              <mat-option [value]="group.id">
                <p>
                  <b>{{ group.name }} </b>
                </p>
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-card appearance="outlined">
          <mat-card-header>
            <mat-card-title class="no-margin">
              <mat-icon style="color: blue;" matTooltip="Users in the current group: {{selectedGroup.basicName}}"
                matTooltipPosition="above">
                group
              </mat-icon>
              ({{members.length}}) Users in {{ selectedGroup.basicName }}
            </mat-card-title>
            <hr />
            <!-- <mat-card-subtitle findGroupDetails class="text small-text">
            User that are in this group
          </mat-card-subtitle> -->
        </mat-card-header>
        <hr />
        <mat-card-content>
          @if (members.length > 0) {
            <div>
              @for (member of members; track member; let i = $index) {
                <ul style="padding: 0">
                  @if (members.length > 0) {
                    <div class="col-12 narrow-button">
                      <button mat-button color="secondary" matTooltip="Navigate to {{member.userName}} details"
                        matTooltipPosition="above" (click)="navigateUrl('users', member)">
                        <span class="big-button-text">{{member.userName}}</span>
                        <br>
                          <span class="small-button-text">({{ member.authUsername }})</span>
                        </button>
                        <button color="warn" matTooltip="Remove User from {{selectedGroup.basicName}}"
                          matTooltipPosition="above" (click)="removeUserFromGroup(member.id)" class="btn btn-primary w-25 float-right"
                          style="background-color: red;" type="button">
                          Remove
                        </button>
                      </div>
                    } @else {
                      <p class="text label-text">No members found</p>
                      <p class="text small-text">Add members from left column or refresh your search params</p>
                    }
                    <hr />
                  </ul>
                }
              </div>
            } @else {
              <button mat-icon-button color="warn" matTooltip="Assign users to this selected group"
                matTooltipPosition="above">
                <mat-icon style="font-size: xxx-large;">close</mat-icon>
                <!-- {{ scout.scoutName }} -->
              </button>
              <p class="text label-text">No user members found!</p>
              <p class="text small-text">Double check the users assigned to this group</p>
            }
          </mat-card-content>
        </mat-card>
        <mat-card appearance="outlined">
          <mat-card-header>
            <hr />
            <mat-card-title class="no-margin">
              <mat-icon style="color: blue;" matTooltip="Scouts in the current group: {{selectedGroup.basicName}}"
                matTooltipPosition="above">
                wifi_tethering
              </mat-icon>
              ({{scouts.length}}) Scouts in {{ selectedGroup.basicName }}
            </mat-card-title>
            <hr />
            <!-- <mat-card-subtitle class="text small-text">
            Scouts in this group
          </mat-card-subtitle> -->
        </mat-card-header>
        <hr />
        <mat-card-content>
          @if (scouts.length > 0) {
            <div>
              @for (scout of scouts; track scout; let i = $index) {
                <ul style="padding: 0">
                  @if (scouts.length > 0) {
                    <div class="col-12 narrow-button">
                      <button mat-button color="secondary" matTooltip="Navigate to {{scout.scoutName}} details"
                        matTooltipPosition="above" (click)="navigateUrl('scouts', scout)">
                        <span class="big-button-text">{{ scout.assetName }}</span>
                        <br>
                          @if (scout.assetName != scout.scoutName) {
                            <span class="small-button-text">
                              ({{ scout.scoutName}})
                            </span>
                          }
                        </button>
                        <button color="warn" matTooltip="Remove Scout from {{selectedGroup.basicName}}"
                          matTooltipPosition="above" (click)="removeScoutFromGroup(scout.id)" class="btn btn-primary w-25 float-right"
                          style="background-color: red;" type="button">
                          Remove
                        </button>
                      </div>
                    } @else {
                      <p class="text label-text">No scouts found</p>
                      <p class="text small-text">Add scouts from left column or refresh your search params</p>
                    }
                    <hr />
                  </ul>
                }
              </div>
            } @else {
              <button mat-icon-button color="warn" matTooltip="Assign assets to this customer" matTooltipPosition="above"
                (click)="openAssetDialog()">
                <mat-icon style="font-size: xxx-large;">close</mat-icon>
                <!-- {{ scout.scoutName }} -->
              </button>
              <p class="text label-text">No scouts found!</p>
              <p class="text small-text">Double check the assets assigned to this customer</p>
            }
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  }
</div>